import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function AdministrarPlantillas() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [userPermissions, setUserPermissions] = useState([]);
    const [oldPermissions, setOldPermissions] = useState([]);

    const hasPermission = (permissionSlug) => {
        const checkNew = userPermissions.some(permission => permission.slug === permissionSlug);
        if (checkNew) return true;
        return oldPermissions.includes(permissionSlug);
    };

    useEffect(() => {

        if (!localStorage.getItem('userdata')) {
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            setUserPermissions(userdata.permissions);
        }

        if (userdata.up && Array.isArray(userdata.up)) {
            setOldPermissions(userdata.up);
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => {
                setLoggedIn(true);
            });
    }, []);

    if (loggedIn) {
        return (
            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="k2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item active" key="k3">Plantillas</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-end">
                                <div className="col-md-8">
                                    <div className="dash-wrap">
                                        <h1 className="dash-title">Plantillas clínicas</h1>
                                        <p className="dash-subtitle mb-0">Evolución, fórmulas, exámenes y más</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/settings" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver a configuración
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="dash-card mb-4">
                                <div className="dash-card-header">
                                    <h2 className="dash-card-title">
                                        <span className="title-icon" aria-hidden="true"><i className="fas fa-file-medical"></i></span>
                                        Opciones
                                    </h2>
                                </div>
                                <div className="dash-card-body">
                                    <div className="quick-grid">
                                        <Link to="/parametros-evolucion" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-stethoscope"></i></div>
                                            <p className="quick-title">Parámetros en evolución</p>
                                            <p className="quick-sub">Campos y Estructura</p>
                                        </Link>

                                        <Link to="/plantillas-formulas" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-pills"></i></div>
                                            <p className="quick-title">Fórmulas médicas</p>
                                            <p className="quick-sub">Prescripciones</p>
                                        </Link>

                                        <Link to="/plantillas-otros-documentos" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-alt"></i></div>
                                            <p className="quick-title">Otros Documentos</p>
                                            <p className="quick-sub">Título y contenido libre</p>
                                        </Link>

                                        <Link to="/plantillas-examenes" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-vial"></i></div>
                                            <p className="quick-title">Exámenes de laboratorio</p>
                                            <p className="quick-sub">Órdenes y Resultados</p>
                                        </Link>

                                        <Link to="/plantillas-recomendaciones" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-comment-medical"></i></div>
                                            <p className="quick-title">Recomendaciones</p>
                                            <p className="quick-sub">Indicaciones al Paciente</p>
                                        </Link>

                                        <Link to="/plantillas-incapacidades" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-medical-alt"></i></div>
                                            <p className="quick-title">Incapacidades y certificados</p>
                                            <p className="quick-sub">Documentos Laborales</p>
                                        </Link>

                                        <Link to="/plantillas-eventos-adversos" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-exclamation-triangle"></i></div>
                                            <p className="quick-title">Eventos adversos</p>
                                            <p className="quick-sub">Reporte y Plantillas</p>
                                        </Link>

                                        <Link to="/plantillas-consentimientos" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-signature"></i></div>
                                            <p className="quick-title">Consentimientos informados</p>
                                            <p className="quick-sub">Textos Legales</p>
                                        </Link>

                                        <Link to="/otras-plantillas" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-folder-open"></i></div>
                                            <p className="quick-title">Plantillas de Evolucion</p>
                                            <p className="quick-sub">Personalizadas</p>
                                        </Link>

                                        <Link to="/plantillas-historia-clinica-json" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-book-medical"></i></div>
                                            <p className="quick-title">Historias clínicas</p>
                                            <p className="quick-sub">Administración Historias</p>
                                        </Link>

                                        {hasPermission('ripsPaciente') && (
                                            <Link to="/administrar-servicios-rips" className="quick-card">
                                                <div className="quick-ico"><i className="fas fa-clipboard-list"></i></div>
                                                <p className="quick-title">Plantillas RIPS</p>
                                                <p className="quick-sub">CUPS y plantillas de consulta/procedimiento</p>
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default AdministrarPlantillas;
